
import {
  UserAgentApplication, Configuration, AuthenticationParameters,
  AuthResponse, InteractionRequiredAuthError
} from 'msal';
import { isIE, isSafari } from '../utils/common';
import Oidc,{User, WebStorageStateStore} from 'oidc-client'
console.log("isSafari", isSafari(), "isIE", isIE())
console.log("process.env",process.env)
const envObj = process.env;
// Config object to be passed to Msal on creation
//const authority = "https://login.chinacloudapi.cn/common";
// const msalConfig: Configuration = {
//   auth: {
//     clientId: envObj.REACT_APP_MSAL_CLIENT_ID as string,
//     authority,
//     redirectUri: () => window.location.origin + "/redirect",
//     // envObj.REACT_APP_MSAL_REDIRECT_URI,
//     navigateToLoginRequestUrl: false,
//     postLogoutRedirectUri: () => window.location.origin,
//     // envObj.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI,
//     validateAuthority: false
//   },
//   cache: {
//     cacheLocation:isSafari()?"sessionStorage": "localStorage", // This configures where your cache will be stored
//     storeAuthStateInCookie: isIE(), // Set this to "true" if you are having issues on IE11 or Edge
//   }
// };
var config = {
  authority: envObj.REACT_APP_IDENTIDY_URL,
  client_id: "mdm",
  redirect_uri:  window.location.origin + "/redirect",
  response_type: "code",
  scope:"openid email offline_access",
  client_secret:envObj.REACT_APP_IDENTIDY_CLIENT_SECRET,
  post_logout_redirect_uri : window.location.origin,
  silent_redirect_uri:  window.location.origin + "/refresh",
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({
    store: localStorage
  }),
};
var manager = new Oidc.UserManager(config);
export const getLoginCallback= async (): Promise<User> => {
  return new Promise((resolve, reject) => {
    manager.signinRedirectCallback().then(c=>{
      console.log("signinRedirectCallback",c)
      if(c){
        manager.storeUser(c)
        resolve(c)
      }else{
        resolve(c)
      }
    })
  })
}


// export const MSALObj = new UserAgentApplication(msalConfig);

// MSALObj.handleRedirectCallback((error, res) => {
//   /* res && console.log(res);
//   error && console.error(error); */
// });

export const GetLogAccount = async (): Promise<User> =>  {
  return new Promise((resolve, reject) => {
     manager.getUser().then(user=>{
        if(user){
          resolve(user);
        }else{
          
          reject(null);
        }
     })
  })
  //return MSALObj.getAccount();
}

export const GetAccount = async (): Promise<User> => {
  var exUser = await manager.getUser();

  return new Promise((resolve, reject) => {
    if (exUser) {
      manager.getUser().then(user => {
        if (user) {
          resolve(user);
        } else {

          reject(null);
        }
      })
    } else {
      reject(null);
    }

  })
}


export const RefushToken = async (): Promise<User> => {

  console.log("RefushToken")
  return new Promise((resolve, reject) => {
    manager.signinSilent().then(c => {
      resolve(c);
    })
      .catch((err) => {
        console.log("refresh", err);
        reject(err);

      });
    //  .then(user=>{
    //    console.log("manager.signinRedirectCallback()",user)
    //     if(user){
    //       resolve(user);
    //     }else{

    //       reject(null);
    //     }
    //  })
  })
  //return MSALObj.getAccount();
}

export const RefushTokenCallBack = async (): Promise<User> =>  {
  return new Promise((resolve, reject) => {
     manager.signinRedirectCallback().then(c=>{
        resolve(c);
     })
     .catch((err) => {
      console.log("RefushTokenCallBack", err);
      reject(null);

    });
    //  .then(user=>{
    //    console.log("manager.signinRedirectCallback()",user)
    //     if(user){
    //       resolve(user);
    //     }else{
          
    //       reject(null);
    //     }
    //  })
  })
  //return MSALObj.getAccount();
}
export const MSALObjLogin = () => {

  manager.signinRedirect();
  // console.log("MSALObjLogin")
  // MSALObj.loginRedirect(loginRequest);
}

export const MSALObjLogout = (userName = '') => {
  manager.signoutRedirect();
  // console.log("MSALObjLogout")
  // MSALObj.authority = authority;
  // MSALObj.logout(userName);
}

export const AcquireToken = async (): Promise<User> => {
  return new Promise((resolve, reject) => {
      try {
        manager.getUser().then(c=>{
          if(c){
            resolve(c)
          }else{
            reject(c)
          }
        })
      //   //MSALObj.acquireTokenPopup(tokenRequest).then(function (accessTokenResponse) {
      //  MSALObj.acquireTokenSilent(tokenRequest).then(function (accessTokenResponse) {
      //     resolve(accessTokenResponse);
      //   }).catch(function (error) {
      //     console.log("acquireTokenSilentError", error)
      //     // if (error.errorCode === "consent_required"
      //     //   || error.errorCode === "interaction_required"
      //     //   || error.errorCode === "login_required") {

      //     //   MSALObj.acquireTokenPopup(tokenRequest).then(function (accessTokenResponse) {
      //     //     resolve(accessTokenResponse);
      //     //   }).catch(function (error) {
      //     //     console.log(error);
      //     //     reject(error);
      //     //   });
      //     // }
      //     var isAuthError = false;
      //     if (error instanceof InteractionRequiredAuthError) {
      //       isAuthError = true;
      //     }
      //     if (isAuthError) {
      //       if (error?.ErrorMessage?.claims) {
      //         tokenRequest.claimsRequest = JSON.stringify(error.ErrorMessage.claims);
      //       }
      //     }
      //     //   MSALObj.acquireTokenSilent(tokenRequest).then(function (accessTokenResponse) {
      //     //     resolve(accessTokenResponse);
      //     //   }).catch(function (error) {
      //     //     console.log(error);
      //     //     reject(error);
      //     //   });
      //     // }
      //     MSALObj.acquireTokenSilent(tokenRequest).then(function (accessTokenResponse) {
      //       resolve(accessTokenResponse);
      //     }).catch(function (error) {
      //       reject(error);
      //     });
      //   })

      } catch (error) {
        console.error(error, 'authinstance')
        reject(error);
      }


  });
}

// export const MSALObjAcquireTokenRedirect = () => {
//   MSALObj.acquireTokenRedirect({ scopes: [envObj.REACT_APP_MSAL_CLIENT_ID as string] });
// }

export const CatchAuthError = (error: any) => {
  // if (error?.name === "InteractionRequiredAuthError") {
  //   console.log(JSON.stringify(error))
  //   MSALObjAcquireTokenRedirect();
  // }
}


export const AcquireApplicationsToken = async (): Promise<AuthResponse> => {
  // if (GetLogAccount()) {
  //   try {
  //     return MSALObj.acquireTokenSilent(AllGraphTokenRequest);
  //   } catch (error) {
  //     // time out etc.
  //     // MSALObj.acquireTokenRedirect(loginRequest);
  //     console.error(error)
  //     return new Promise((resolve, reject) => {
  //       reject(null);
  //     });
  //   }
  // }

  return new Promise((resolve, reject) => {
    reject(null)
  });
}



